import { connect } from 'react-redux';

import SelectGlobalDistrict from '../components/SelectGlobalDistrict';

import { selectClassroom } from '../actions/classrooms';
import { fetchDistricts, selectDistrict } from '../actions/districts';
import { selectSchool } from '../actions/schools';
import { selectStudent } from '../actions/students';

const mapStateToProps = (state) => {
	return {
		districts: state.districts.list,
		isFetching: state.districts.isFetching,
		selectedDistrict: state.districts.selected
	};
};

const mapDispatchToProps = {
	fetchDistricts,
	selectClassroom,
	selectDistrict,
	selectSchool,
	selectStudent
};

export default connect(mapStateToProps, mapDispatchToProps)(SelectGlobalDistrict);



// WEBPACK FOOTER //
// ./frontend/a2i/js/containers/SelectGlobalDistrict.jsx